import { render, staticRenderFns } from "./c_foot.vue?vue&type=template&id=2961ee3a&scoped=true"
import script from "./c_foot.vue?vue&type=script&lang=js"
export * from "./c_foot.vue?vue&type=script&lang=js"
import style0 from "./c_foot.vue?vue&type=style&index=0&id=2961ee3a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2961ee3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2961ee3a')) {
      api.createRecord('2961ee3a', component.options)
    } else {
      api.reload('2961ee3a', component.options)
    }
    module.hot.accept("./c_foot.vue?vue&type=template&id=2961ee3a&scoped=true", function () {
      api.rerender('2961ee3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_foot.vue"
export default component.exports